import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useBusinessRules() {
  const [rules, setRules] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    api.get("/business-rules")
      .then(({ data }) => active && setRules(data))
      .catch(() => active && setError("Reglerne kunne ikke hentes. Prøv igen."));
    return () => { active = false; };
  }, []);

  return { rules, error };
}

export const customerRulesPath = "/betaling-afbud-og-moedetid";
export const expertRulesPath = "/regler-for-opgaver-og-betaling";
